import { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Hook for fetching version information from the CMS API
 * @returns {Object} Version information and loading state
 */
export const useVersion = () => {
    const [version, setVersion] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchVersion = async () => {
            try {
                setLoading(true);
                const response = await axios.get('/version');
                setVersion(response.data);
                setError(null);
            } catch (err) {
                console.error('Failed to fetch version:', err);
                setError(err);
                // Fallback to default version if API fails
                setVersion({
                    version: '1.2.7',
                    displayVersion: 'v1.2.7',
                    fullVersion: '1.2.7.0'
                });
            } finally {
                setLoading(false);
            }
        };

        fetchVersion();
    }, []);

    return { version, loading, error };
};
